import * as React from "react";

import { RiCloseLine } from "react-icons/ri";

import "./Modal.scss";

const Modal = (props) => {
  const {
    children,
    isOpen = false,
    onClose,
    isDismissible = true,
    withCloseButton = false,
    title,
    className,
    size = "md",
  } = props;

  const [open, setOpen] = React.useState(!!isOpen);

  const modalRef = React.useRef(null);

  React.useEffect(() => {
    setOpen(!!isOpen);
  }, [isOpen]);

  React.useEffect(() => {
    if (modalRef.current && open) {
      modalRef.current.focus();
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  const closeOnESC = (e) => {
    if (e.key === "Escape") {
      handleClose();
    }
  };

  const modalSizeClassName = () => {
    switch (size) {
      case "xs":
        return "custom-modal--xs";
      case "sm":
        return "custom-modal--sm";
      case "lg":
        return "custom-modal--lg";
      default:
        return "custom-modal--md";
    }
  };

  return open ? (
    <>
      <div className="custom-modal-backdrop" />
      <div
        ref={modalRef}
        className="custom-modal-wrapper"
        tabIndex={0}
        onKeyDown={closeOnESC}
        onClick={() => isDismissible && handleClose()}
      >
        <div
          className={`custom-modal ${modalSizeClassName()} ${
            className ? className : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="custom-modal-header ">
            {!!title && <h2 className="custom-modal-header-text">{title}</h2>}
            {withCloseButton && (
              <span
                onClick={handleClose}
                className="custom-modal-header-close-btn"
              >
                <RiCloseLine className="close-icon" />
              </span>
            )}
          </div>

          <div className="custom-modal-body">{children}</div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default Modal;
